module.exports = __webpack_public_path__ + "static/media/john.2e623e59.png";